export default "__VITE_ASSET__6UUuiba5__"